export default __webpack_public_path__ + "static/media/fireflink-assets.46ed0fbf.svg";